// Course content scraped from limedrivingschool.com (Feb 2026).
// Used by both /packages (listing) and /packages/:slug (detail).
export const PACKAGES = [
  {
    slug: "standard",
    product: "standard", // key used by Book.jsx ?product=
    title: "Standard 2-Hour Lesson",
    headline: "Pay as you go",
    hours: 2,
    price: "£78 per 2-hour lesson",
    blurb: "£39 per hour. Minimum 2-hour lesson (£78). Pay only for what you book.",
    description: `All lessons and courses are designed to suit your specific needs, requirements and abilities.
                  Lessons are normally 2 hours long and it's recommended you take these once a week to
                  maximise your progress. Collection and return can be made to a location of your choice.`,
    image: "https://images.unsplash.com/photo-1502877338535-766e1452684a?auto=format&fit=crop&w=1200&q=70",
    ctaLabel: "Book a standard lesson",
  },
  {
    slug: "10-hour",
    product: "package10",
    title: "10 Hour Package",
    headline: "Save with a 10-hour block",
    hours: 10,
    price: "£380 — £38/hour",
    blurb: "Book 10 hours up-front and enjoy a reduced hourly rate of £38 (apply code LIME10 at checkout).",
    description: `All lessons and courses are designed to suit your specific needs, requirements and abilities.
                  Lessons are a minimum of 2 hours long and it's recommended you take at least one lesson per
                  week to maximise your progress. Collection and return can be made to a location of your choice.`,
    image: "https://images.unsplash.com/photo-1449965408869-eaa3f722e40d?auto=format&fit=crop&w=1200&q=70",
    ctaLabel: "Book the 10-hour package",
  },
  {
    slug: "20-hour",
    product: "package20",
    title: "20 Hour Package",
    headline: "Best value for new learners",
    hours: 20,
    price: "£740 — £37/hour",
    blurb: "Book 20 hours up-front and enjoy our lowest hourly rate of £37 (apply code LIME20 at checkout).",
    description: `All lessons and courses are designed to suit your specific needs, requirements and abilities.
                  Lessons are a minimum of 2 hours long and it's recommended you take at least one lesson per
                  week to maximise your progress. Collection and return can be made to a location of your choice.`,
    image: "https://images.unsplash.com/photo-1492144534655-ae79c964c9d7?auto=format&fit=crop&w=1200&q=70",
    ctaLabel: "Book the 20-hour package",
  },
  {
    slug: "bespoke",
    product: "bespoke",
    title: "Intensive Courses",
    headline: "Pass fast — intensive courses from 10 to 35 hours",
    hours: null,
    price: "From £500",
    blurb: "Pass your test in a compressed timescale. Intensive courses at Southampton & Winchester test centres only — 10, 20 or 35 hour options.",
    description: `Our intensive courses are designed to get you test-ready in weeks, not months.
                  Choose from three options to match your experience: Advanced (10 hrs), Intermediate (20 hrs),
                  or Beginner (35 hrs, with free Theory Test Pro subscription included). Pass-guarantee refund
                  on your second test. Southampton & Winchester test centres only.`,
    image: "https://images.unsplash.com/photo-1503376780353-7e6692767b70?auto=format&fit=crop&w=1200&q=70",
    ctaLabel: "Explore intensive courses",
    enquireOnly: true, // bespoke -> contact rather than checkout
  },
];

// What you learn — identical for every course on the live site.
export const COURSE_CHECKLIST = [
  ["Cockpit drill", "Safety checks", "Moving away and stopping",
   "Your position on the road", "Mirrors and blind spots",
   "Junctions and roundabouts", "Meeting traffic", "Emergency stop", "Parallel parking"],
  ["Hazard awareness", "Turning your car", "Reversing",
   "Planning and independent driving", "Darkness and weather conditions",
   "Passengers and loads", "Security", "Using satellite navigation"],
];

export const COURSE_BENEFITS = [
  "Your personal DVSA certified instructor",
  "Free practice theory test with Safe Driving for Life",
  "Competitive driving lesson hourly rates",
  "No quibble refund policy",
];

export function getPackage(slug) {
  return PACKAGES.find(p => p.slug === slug);
}
